module.exports = __webpack_public_path__ + "img/06.be63f6cd.png";